module.exports = __webpack_public_path__ + "static/edge-baf156e2109444502b9788c4d3ae174f.png";